import styled from 'styled-components';

const base = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15%;
  background-color: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0px 0.25rem 0.25rem 0px rgba(0, 0, 0, 0.1);
  height: 25rem;
  width: 37rem;
`;

const Frame = {
  Base: base,
};

export default Frame;
